import { PlacementTaskStatus } from '@common/enums';
import { SvgIconComponent } from '@mui/icons-material';
import { Icon } from '@common-components';
import {
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
  PublishedWithChanges as PublishedWithChangesIcon,
} from '@icons';

interface PlacementTaskStatusIconProps {
  status: PlacementTaskStatus;
}

const iconConfig: Record<PlacementTaskStatus, { icon: SvgIconComponent; color: string }> = {
  [PlacementTaskStatus.Completed]: {
    icon: CheckCircleIcon,
    color: 'green.600',
  },
  [PlacementTaskStatus.InProgress]: {
    icon: PublishedWithChangesIcon,
    color: 'blue.600',
  },
  [PlacementTaskStatus.Planned]: {
    icon: PendingIcon,
    color: 'text.secondary',
  },
  [PlacementTaskStatus.Skipped]: {
    icon: PendingIcon,
    color: 'text.secondary',
  },
};

export function PlacementTaskStatusIcon({ status }: PlacementTaskStatusIconProps) {
  const config = iconConfig[status];

  return <Icon component={config.icon} sx={{ width: 20, height: 20, color: config.color }} />;
}
